// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qpTM","footer":"styles_footer__1YVWK","passCodeTooltip":"styles_passCodeTooltip__1bP5Z"};